import { useStoreState } from '@/store'

export default function TableSubHeader() {
  const { queryResponse, totalResults} = useStoreState(
    state => state.search
  )

  if (!totalResults) {
    return null
  }

  return (
    <p className="text-base text-gray-700 mb-8">
      Looking for one of the {totalResults} real estate
      agents in {queryResponse.location_data.primary_location.city} based on our current data? Find the right agent for
      you by using the search filters below. Make a selection to start
      connecting.
    </p>
  )
}
